import * as types from '../mutation-types'

const state = {
	errorMsg: null,
	infoMsg: null,
	successMsg: null
}

const getters = {
	errorMsg: state => state.errorMsg,
	infoMsg: state => state.infoMsg,
	successMsg: state => state.successMsg
}

const actions = {
	
}

const mutations = {
	[types.SET_ERROR_MSG] (state, msg) {
		state.errorMsg = msg
	},
	[types.SET_INFO_MSG] (state, msg) {
		state.infoMsg = msg
	},
	[types.SET_SUCCESS_MSG] (state, msg) {
		state.successMsg = msg
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}
